module.exports = __webpack_public_path__ + "img/IMG_0478.55d410f5.jpg";